module.exports = __webpack_public_path__ + "img/05_full.4ffcb835.jpg";